"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./style.css");
const Spinner = props => {
  const {
    className,
    diameter,
    loadingtext,
    spinnerposition,
    thickness
  } = props;
  const spinnerStyle = {
    width: diameter,
    height: diameter,
    border: thickness,
    borderRightColor: 'transparent'
  };
  const newprops = {
    ...props,
    className: (0, _classnames.default)("ixn-spinner__".concat(className))
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ixn-spinner"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ixn-spinner__spinner-component ixn-spinner__".concat(spinnerposition)
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Spinner, (0, _extends2.default)({}, newprops, {
    style: spinnerStyle
  })), loadingtext.trim().length > 0 && /*#__PURE__*/_react.default.createElement("p", {
    className: "ixn-spinner__loading-text"
  }, loadingtext)));
};
exports.Spinner = Spinner;
Spinner.defaultProps = {
  loadingtext: 'Loading',
  className: 'spinner-icon',
  spinnerposition: 'window',
  diameter: '7rem',
  thickness: '.6em solid currentColor'
};
Spinner.propTypes = {
  /** Specifies the loading text to display below the loader */
  loadingtext: _propTypes.default.string,
  /** Specifies custom class name */
  className: _propTypes.default.string,
  /** Specify spinner position according to window or container */
  spinnerposition: _propTypes.default.oneOf(['window', 'container']),
  /** Shows the spinner size, default diameter size is '7rem' */
  diameter: _propTypes.default.string,
  /** Shows the spinner border, default thickness is '.6em solid currentColor' */
  thickness: _propTypes.default.string
};